import { Typography } from "@mui/material";
import { MOBILE_BREAKPOINT } from "../../styles/responsive";

interface Props {
  children: React.ReactNode;
}
export const PageTitle: React.FC<Props> = ({ children }) => {
  return (
    <Typography
      className="PageTitle"
      sx={{
        // SP は 20px、PC は 24px
        fontSize: { xs: "20px", [MOBILE_BREAKPOINT]: "24px" },
        fontWeight: "700",
      }}
    >
      {children}
    </Typography>
  );
};
